import React from 'react';
import * as RadixToast from '@radix-ui/react-toast';
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react';

const ICONS = {
    success: CheckCircle,
    error: XCircle,
    warning: AlertTriangle,
    info: Info,
};

const Toast = ({ id, message, type = 'info', onClose, duration = 4000 }) => {
    const Icon = ICONS[type] ?? Info;

    return (
        <RadixToast.Root
            className={`toast toast-${type}`}
            duration={duration}
            onOpenChange={(open) => { if (!open) onClose(id); }}
            defaultOpen
        >
            <RadixToast.Description asChild>
                <div style={{ display: 'contents' }}>
                    <Icon className="toast-icon" size={18} aria-hidden="true" />
                    <span className="toast-body">{message}</span>
                </div>
            </RadixToast.Description>
            <RadixToast.Close asChild>
                <button className="toast-close" aria-label="Dismiss notification">
                    <X size={14} />
                </button>
            </RadixToast.Close>
        </RadixToast.Root>
    );
};

export default Toast;
